"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = __importDefault(require("localized-strings"));
var react_1 = require("react");
var hoursMinutesSeconds_i18n_1 = require("../util/formatting/hoursMinutesSeconds.i18n");
function useLocalisation(values, language) {
    // @ts-ignore The types are too weak in the lib. If we use our own that match the typedef but
    // also ensures that all languages are covered then we are in better shape than matching the
    // much looser types for the sake of avoiding the use of ts-ignore
    var strings = react_1.useMemo(function () { return new localized_strings_1.default(values); }, []);
    if (language) {
        language = getTranslationLanguage(language);
        strings.setLanguage(language);
    }
    var initialLanguage = react_1.useRef(language);
    // odd syntax but we only need to setter for this state to trigger
    // a render when the language changes
    var _a = react_1.useState(false), setLanguageChanged = _a[1];
    if (language !== initialLanguage.current) {
        strings.setLanguage(language);
        initialLanguage.current = language;
        setLanguageChanged(true);
    }
    return strings;
}
exports.useLocalisation = useLocalisation;
function getLocalisation(values, language) {
    // @ts-ignore The types are too weak in the lib. If we use our own that match the typedef but
    // also ensures that all languages are covered then we are in better shape than matching the
    // much looser types for the sake of avoiding the use of ts-ignore
    var strings = new localized_strings_1.default(values);
    if (language) {
        language = getTranslationLanguage(language);
        strings.setLanguage(language);
    }
    return strings;
}
exports.getLocalisation = getLocalisation;
function formatString(str) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var ls = new localized_strings_1.default(hoursMinutesSeconds_i18n_1.hoursMinutesSecondsTranslations);
    return ls.formatString.apply(ls, __spreadArrays([str], values));
}
exports.formatString = formatString;
function getBrowserLanguage() {
    return new localized_strings_1.default(hoursMinutesSeconds_i18n_1.hoursMinutesSecondsTranslations).getLanguage();
}
exports.getBrowserLanguage = getBrowserLanguage;
var translationLanguageMap = {
    "en-AU": "en-GB",
};
function getTranslationLanguage(lang) {
    //Some languages/locales that we support will not have their own specific dictionary.
    // Rather they will be assigned an existing dictionary
    //This method returns the language used for the translations in this case (or the original language string otherwise)
    var translationLang = translationLanguageMap[lang];
    return translationLang ? translationLang : lang;
}
